import Util from 'root/module/util';
import Cache from 'root/cache';
import Modals from 'root/modals';
import View from 'view/base';

export default View.extend({
    tagName: 'tr',

    events: {
        'click .revoke': 'revoke'
    },

    dom_handlers: {
        revoke: function(e) {
            Modals.deleteApiToken(this.model.id);
        }
    },

    initialize: function() {
        this.listenTo(this.model, 'change', this.render);
    },

    render: function() {
        var content = '';

        var user = Cache.user.get(this.model.escape('user_id'));
        var created_by = user ? user.escape('name') : '<span class="strike">Deleted user</span>';

        content += '<td>' + this.model.escape('name') + '</td>' +
                    '<td>'+ Util.moment(this.model.get('last_accessed'), undefined, undefined, undefined, 'Never accessed') + '</td>' +
                    '<td>' + created_by + '<br><span class="info">' + Util.moment(this.model.get('create_time')) + '</span></td>' +
                    '<td class="text-align-right">' +
                        '<button class="revoke small primary primary-invert">Revoke</button>' +
                    '</td>';

        this.$el.html(content);

        return this;
    }
});